// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-effects[data-v-19c0a2ba]{flex:1;position:relative}.preview-effects__content-list[data-v-19c0a2ba]{overflow:auto}.preview-effects__list[data-v-19c0a2ba]{display:grid;grid-auto-flow:column;gap:6px;width:200px}.preview-effects__loading[data-v-19c0a2ba]{text-align:center;font-size:16px;padding:6px;border-radius:5px;margin-bottom:6px;color:#ffc107;border:1px solid #ff9800}", ""]);
// Exports
module.exports = exports;
